import __ from "../../../../core/utils/translate/translate";

export const NOJAHAN_STATISTICS = [
    {id: "users", title: __("Nojahan teenagers"), image: "/images/intro-users.png"},
    {id: "teams", title: __("Nojahan team"), image: "/images/intro-teams.png"},
    {id: "groups", title: __("Nojahan group"), image: "/images/intro-groups.png"},
    {id: "organizations", title: __("Nojahan collections"), image: "/images/intro-organizations.png"},
];
